<template>
  <div class="files-breadcrumbs__item"
    ref="breadCrumbItem"
    :style="minWidth"
  >
    <a
      v-if="!isLast"
      class="files-breadcrumbs__anchor no-decoration grey--text text--darken-1"
      @click.prevent="$router.push({
            path: `/pliki/klient/${breadcrumb.client_id}/katalog/${breadcrumb.item_id}`,
            query: queryData,
          })">
      <v-icon color="grey" class="files-breadcrumbs__icon mr-1">chevron_right</v-icon>
      <div class="files-breadcrumbs__name">
        {{breadcrumb.name}}
      </div>
    </a>
    <div
      v-if="isLast"
      class="files-breadcrumbs__name">
      {{breadcrumb.name}}
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'BreadcrumbsList',
  props: [
    'breadcrumb',
    'length',
    'index',
    'isBigger',
    'itemMinWidth',
    'recalculate',
  ],
  data: () => ({
    itemWidth: null,
    minWidth: null,
  }),
  computed: {
    ...mapGetters('files', [
      'breadcrumbs',
    ]),
    isLast() {
      return this.index + 1 === this.length;
    },
    queryData() {
      const { query } = this.$route;
      return {
        ...query,
      };
    },
  },
  methods: {
    getItemWidth() {
      if (this.$refs.breadCrumbItem) {
        this.itemWidth = this.$refs.breadCrumbItem.clientWidth;
      }
    },
    getMinWidth() {
      const min = 60;
      const itemWidth = this.itemWidth < this.itemMinWidth ? this.itemWidth / 2 : this.itemMinWidth;
      const width = itemWidth < min ? min : itemWidth;
      const minWidth = this.isBigger ? `${width}px` : 'none';
      this.minWidth = `min-width: ${minWidth}`;
    },
  },
  created() {
    this.getItemWidth();
    this.getMinWidth();
    if (this.recalculate && this.isLast) {
      setTimeout(() => {
        this.recalculate();
      }, 10);
    }
  },
  watch: {
    breadcrumbs() {
      this.getItemWidth();
      this.getMinWidth();
    },
    itemMinWidth(val) {
      if (val) {
        this.getItemWidth();
        this.getMinWidth();
      }
    },
  },
};
</script>

